// How many cards per row the cards view uses (kept apart from the component so it can be unit-tested).
export const CARD_MIN = 280;
const CARD_GAP = 12;

/**
 * Cards per row for a width: as many as fit (each at least CARD_MIN wide), then the count that
 * leaves the fewest empty places in the last row (six stores: 3 + 3 or 6, never 4 + 2), keeping
 * at least half of what fits.
 */
export function cardColumns(width: number, count: number): number {
  const fit = Math.max(1, Math.floor((width + CARD_GAP) / (CARD_MIN + CARD_GAP)));
  if (count <= fit) return Math.max(1, count);
  let best = fit;
  let bestEmpty = (fit - (count % fit)) % fit;
  for (let c = fit - 1; c >= Math.ceil(fit / 2); c--) {
    const empty = (c - (count % c)) % c;
    if (empty < bestEmpty) {
      best = c;
      bestEmpty = empty;
    }
  }
  return best;
}
